import { gql } from '@apollo/client';
import UPDATE_STUDENT_SETTING_FRAGMENT from '../../fragments/update-student-setting-fragment';

const UPDATE_GSS_STUDENT_LANGUAGE_SETTING = gql`
  mutation updateGssStudentSettingLanguage($data: [UpdateGssStudentSettingLocaleInput!]!) {
    updateGssStudentSettingLanguage(data: $data) {
      ...UpdateStudentSettingFragment
    }
  }
  ${UPDATE_STUDENT_SETTING_FRAGMENT}
`;

export default UPDATE_GSS_STUDENT_LANGUAGE_SETTING;
